// components/ReadMoreText/index.jsx
import React from 'react';
import ReadMoreTextBase from './ReadMoreTextBase';
import { useRecordViewOnExpand } from './useRecordViewOnExpand';

/**
 * Backwards-compatible wrapper.
 * Keeps existing props working but routes tracking via a hook.
 * New code should import ReadMoreTextBase directly (no tracking).
 *
 * Deprecated props (kept temporarily):
 *  - docPath
 *  - userId
 *  - onViewed
 */
export default function ReadMoreText(props) {
  const {
    docPath, // deprecated: move view tracking to detail page
    userId, // deprecated
    onViewed, // deprecated
    ...rest
  } = props;

  const onToggle = useRecordViewOnExpand({ docPath, userId, onViewed });

  return <ReadMoreTextBase {...rest} onToggle={onToggle} />;
}

// Optional: re-export base for new usages.
export { ReadMoreTextBase };
